import { Switch } from "@mui/material";
import { RequestServiceLog } from "interfaces";
import { useEffect, useState } from "react";
import { useNetworkLogsObserver } from "./helpers/networkLogsObserver";

interface NetworkLogsProps {
	onFocusChange: (focused: boolean) => void;
}

export const NetworkLogs = ({ onFocusChange }: NetworkLogsProps) => {
	const [filterNetworkText, setFilterNetworkText] = useState("");
	const [minNetworkDuration, setMinNetworkDuration] = useState(0);
	const [switchNetworkLogs, setSwitchNetworkLogs] = useState(false);
	const [networkLogs, setNetworkLogs] = useState<RequestServiceLog[]>([]);
	const filteredNetworkLogs = networkLogs.filter(
		(log) =>
			log.url.toLowerCase().includes(filterNetworkText.toLowerCase()) &&
			log.duration >= minNetworkDuration
	);

	useNetworkLogsObserver(setNetworkLogs);

	useEffect(() => {
		switchNetworkLogs &&
			document.getElementById("network-logs-end")?.scrollIntoView();
	}, [switchNetworkLogs]);

	return (
		<div>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					maxWidth: "100%",
					padding: "0.2rem"
				}}
			>
				<strong>Service Logs</strong>
				<Switch
					checked={switchNetworkLogs}
					onChange={(e) => setSwitchNetworkLogs(e.target.checked)}
				/>
			</div>
			<br />
			{switchNetworkLogs && (
				<div
					id="network-logs"
					style={{
						background: "#111",
						color: "#0f0",
						fontFamily: "monospace",
						padding: "1rem",
						border: "1px solid #0f0",
						borderRadius: "8px",
						maxWidth: "100%",
						marginBottom: "5rem"
					}}
				>
					<h3 style={{ marginTop: 0 }}>📡 Request Debug</h3>
					<div style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}>
						<div>
							🔍 URL:{" "}
							<input
								type="text"
								placeholder="URL filter"
								value={filterNetworkText}
								onChange={(e) => setFilterNetworkText(e.target.value)}
								onFocus={() => onFocusChange(true)}
								onBlur={() => onFocusChange(false)}
								style={{
									background: "#222",
									color: "#0f0",
									border: "1px solid #0f0",
									padding: "4px",
									fontFamily: "monospace"
								}}
							/>
						</div>
						<div>
							⏱ min time (ms):{" "}
							<input
								type="number"
								min={0}
								value={minNetworkDuration}
								onChange={(e) => setMinNetworkDuration(Number(e.target.value))}
								style={{
									background: "#222",
									color: "#0f0",
									border: "1px solid #0f0",
									padding: "4px",
									width: "80px",
									fontFamily: "monospace"
								}}
							/>
						</div>
					</div>
					<div style={{ maxHeight: "300px", overflowY: "auto" }}>
						{filteredNetworkLogs.length === 0 ? (
							<p>No match found</p>
						) : (
							filteredNetworkLogs.map((log, i) => (
								<div key={i}>
									⏱ {log.url} → {log.duration.toFixed(2)} ms
								</div>
							))
						)}
					</div>
				</div>
			)}
			<div id="network-logs-end" />
		</div>
	);
};
